// src/i18n/es/satisfaction.ts
// «Satisfacción» — route /satisfaction, Dirección. La encuesta que el huésped
// contesta al terminar (en el kiosco o con el asistente): valoración media,
// facilidad media, respuestas y comentarios de un hotel y periodo.
export const satisfaction = {
  name: 'Satisfacción |||| Satisfacción',
  subtitle: 'La encuesta de los huéspedes al terminar',

  filters: {
    channel: 'Canal',
    allChannels: 'Todos los canales',
  },

  channels: {
    assistant_phone: 'Asistente en el móvil',
    assistant_kiosk: 'Asistente en la pantalla del kiosco',
    kiosk_screen: 'Pantalla del kiosco',
  },

  tiles: {
    overall: 'Valoración media',
    ease: 'Facilidad media',
    responses: 'Respuestas',
    comments: 'Comentarios',
    scale: 'Escala de 1 a 5',
    responsesNote: 'Recorridos con al menos una pregunta contestada',
    insufficient: 'Muestra insuficiente: %{smart_count} respuesta (mínimo 20) |||| Muestra insuficiente: %{smart_count} respuestas (mínimo 20)',
    commentsNote: 'Respuestas con un comentario escrito',
  },

  answerCount: '%{smart_count} respuesta |||| %{smart_count} respuestas',
  noAnswers: 'Sin respuestas',

  byChannel: {
    title: 'Por canal',
    channel: 'Canal',
    responses: 'Respuestas',
    share: 'Proporción',
  },

  list: {
    title: 'Respuestas',
    onlyWithComment: 'Solo con comentario',
    answeredAt: 'Fecha y hora',
    channel: 'Canal',
    language: 'Idioma',
    overall: 'Valoración',
    ease: 'Facilidad',
    comment: 'Comentario',
    notAnswered: 'Sin respuesta',
    noComment: 'Sin comentario',
    timeZone: 'Horas en la zona horaria del hotel.',
    empty: 'Ninguna respuesta coincide con estos filtros.',
    emptyWithComment: 'Ningún huésped ha dejado un comentario en este periodo.',
  },

  empty: {
    noFeed: 'Este hotel aún no envía encuestas.',
    noFeedHint: 'Las respuestas aparecerán aquí en cuanto los huéspedes contesten la encuesta en el kiosco o en el asistente.',
    noResponses: 'Todavía no hay respuestas en este periodo.',
    noResponsesHint: 'Pruebe con un periodo más amplio o con otro canal.',
  },

  help: {
    title: 'Satisfacción',
    description:
      'Al terminar, el huésped puede valorar su experiencia y la facilidad del proceso de 1 a 5 y dejar un comentario. Esta página reúne esas respuestas por hotel, periodo y canal.',
    features: {
      tiles: 'Cada media va acompañada del número de respuestas en que se basa y solo se muestra con al menos 20; por debajo aparece «Muestra insuficiente» con el número de respuestas. «Respuestas» cuenta recorridos con al menos una pregunta contestada; «Por canal» cuenta cada recorrido una sola vez, en el canal de su valoración general.',
      list: 'La lista muestra cada respuesta con su fecha, canal, idioma y comentario; active «Solo con comentario» para leer únicamente los comentarios.',
    },
    tips: {
      property: 'Cambie de hotel arriba a la izquierda; aparecen los hoteles con datos de check-in o con encuestas. El periodo por defecto son los últimos 30 días.',
    },
  },
};

export default satisfaction;
